import { get } from 'lodash';

import env from '../env';

const jwtDecode = require('jwt-decode');

export const calculateClockDrift = (iatAccessToken, iatIdToken) => {
  const now = Math.floor(new Date() / 1000);
  const iat = Math.min(iatAccessToken, iatIdToken);
  return now - iat;
};

const resolveUsername = ({ idToken, username: usernameOverride }) => {
  if (usernameOverride) {
    return usernameOverride;
  }

  const idTokenData = jwtDecode(idToken);
  const cognitoUsername = get(idTokenData, 'cognito:username');
  if (cognitoUsername) {
    return cognitoUsername;
  }

  const sub = get(idTokenData, 'sub');
  if (sub) {
    return sub;
  }

  throw new Error('Unable to resolve Cognito username from SSO tokens');
};

export function seedCognitoSession({ idToken, accessToken, refreshToken, username: usernameOverride }) {
  const clientId = env.REACT_APP_AWS_COGNITO_USER_POOL_WEBCLIENT_ID;
  if (!clientId) {
    throw new Error('Missing Cognito user pool client id');
  }

  const username = resolveUsername({ idToken, username: usernameOverride });
  const idTokenData = jwtDecode(idToken);
  const accessTokenData = jwtDecode(accessToken);
  const iatIdToken = get(idTokenData, 'iat');
  const iatAccessToken = get(accessTokenData, 'iat');

  const prefix = `CognitoIdentityServiceProvider.${clientId}`;
  const refreshTokenKey = `${prefix}.${username}.refreshToken`;

  localStorage.setItem(`${prefix}.LastAuthUser`, username);
  localStorage.setItem(`${prefix}.${username}.idToken`, idToken);
  localStorage.setItem(`${prefix}.${username}.accessToken`, accessToken);
  // SSO handoff from student-hub intentionally omits refreshToken so this
  // origin cannot refresh independently after exchange.
  if (refreshToken) {
    localStorage.setItem(refreshTokenKey, refreshToken);
  } else {
    localStorage.removeItem(refreshTokenKey);
  }
  localStorage.setItem(`${prefix}.${username}.clockDrift`, `${calculateClockDrift(iatAccessToken, iatIdToken)}`);

  return { username, clientId };
}

export default seedCognitoSession;
